import React, { Component } from "react";

import {
  CSidebar,
  CSidebarForm,
  CSidebarHeader,
  CSidebarNav,
  CSidebarNavItem,
  CSidebarNavDropdown,
  CSidebarNavTitle,
  CLink
} from "@coreui/react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { setMinimizeMenu, setMenu } from "../actions/menuActions";
import logo16 from "../assets/imgs/logo-16.png";
import logoAvaliacao16 from "../assets/imgs/logo-avaliacao-16.png";
import logoAvaliacao from "../assets/imgs/logo-avaliacao-branco.png";
import logoLivros16 from "../assets/imgs/logo-livros-16.png";
import logoLivros from "../assets/imgs/logo-livros-branco.png";
import logo from "../assets/imgs/logo.png";
import logoAlagoas from "../assets/imgs/logoAlagoas.png";

const propTypes = {
  children: PropTypes.node
};

const defaultProps = {};

class Sidebar extends Component {
  removeMenuItem = (menu, menuName, childrenItemName) => {
    const removeChild = (children, name) =>
      children.filter(child => {
        if (child.children) {
          child.children = removeChild(child.children, name);
        }
        return child.name !== name;
      });

    const removeItem = (menu, menuName, childrenItemName) =>
      menu.map(item => {
        if (item.name === menuName && item.children) {
          item.children = removeChild(item.children, childrenItemName);
        } else if (item.children) {
          item.children = removeItem(item.children, menuName, childrenItemName);
        }
        return item;
      });

    return removeItem(menu, menuName, childrenItemName);
  };

  render() {
    let menu = this.props.general.menu.filter(item => item.name !== "Home");

    let userGroup = this.props.general.active_roles.group_id;

    const show = this.props.general.showMenu;
    const minimize = this.props.general.minimizeMenu;

    if (
      this.props.user.user_roles.filter(
        role => role.group_id === 61 || role.group_id === 62
      ).length === 0
    ) {
      const ajudaIndex = menu.findIndex(item => item.name === "Ajuda");
      const stiftIndex = menu[ajudaIndex]?.children?.findIndex(
        item => item.name === "Stift"
      );

      if (stiftIndex > -1) {
        menu[ajudaIndex].children.splice(stiftIndex, 1);
      }
    }

    let imgLogo = logo;
    let imgLogo16 = logo16;

    if (
      [
        "ava.livros.homologa.educandus.net",
        "ava.livros.educandus.net"
      ].includes(window.location.host.toLowerCase())
    ) {
      imgLogo = logoLivros;
      imgLogo16 = logoLivros16;
    } else if (
      [
        "ava.avaliacao.homologa.educandus.net",
        "ava.avaliacao.educandus.net"
      ].includes(window.location.host.toLowerCase())
    ) {
      imgLogo = logoAvaliacao;
      imgLogo16 = logoAvaliacao16;
    }

    if (userGroup === 86 && this.props.user.user_roles[0].role_id === 6) {
      menu.forEach(menuItem => {
        if (menuItem.children) {
          menuItem.children = menuItem.children.filter(
            child => child.id !== 60 && child.id !== 62
          );
        }
      });
    }

    const isDigitalBooks = userGroup === 71;
    if (!isDigitalBooks) {
      return (
        <CSidebar
          id={
            this.props.general.active_roles.group_name === "Alagoas"
              ? "alagoas"
              : "menuAlterado"
          }
          show={show}
          minimize={minimize}
          onShowChange={show => this.props.setMenu(show)}
          onMinimizeChange={minimize => this.props.setMinimizeMenu(minimize)}
        >
          <CSidebarHeader>
            <CLink to="/dashboard">
              {this.props.user.user_roles[0].group_id === 49 ||
              this.props.user.user_roles[0].group_id === 86 ? (
                <img src={logoAlagoas} alt="Alagoas Logo" width="200px" />
              ) : (
                <img src={imgLogo} alt="Educandus Logo" />
              )}
            </CLink>
          </CSidebarHeader>
          <CSidebarForm />
          <CSidebarNav>
            {minimize && (
              <CSidebarNavItem
                id={
                  this.props.general.active_roles.group_name === "Alagoas"
                    ? "alagoas"
                    : ""
                }
              >
                <CLink to="/dashboard" className="c-sidebar-nav-link">
                  <i className="c-sidebar-nav-icon navbar-icon h-auto">
                    <img src={imgLogo16} alt="Educandus Logo" />
                  </i>
                  Página inicial
                </CLink>
              </CSidebarNavItem>
            )}
            {menu.map((title, index) =>
              title.children ? (
                <React.Fragment key={index}>
                  <CSidebarNavTitle>{title.name}</CSidebarNavTitle>
                  {title.children.map((item, index) =>
                    item.children ? (
                      <CSidebarNavDropdown
                        key={index}
                        name={item.name}
                        to={item.url}
                        style={{ fontSize: "14px" }}
                        fontIcon={`${item.icon} navbar-icon`}
                        id={
                          this.props.general.active_roles.group_name ===
                          "Alagoas"
                            ? "alagoas"
                            : ""
                        }
                      >
                        {item.children.map((child, index) => (
                          <CSidebarNavItem
                            key={index}
                            name={child.name}
                            to={child.url}
                            style={{ fontSize: "13px" }}
                            id={
                              this.props.general.active_roles.group_name ===
                              "Alagoas"
                                ? "alagoas"
                                : ""
                            }
                          />
                        ))}
                      </CSidebarNavDropdown>
                    ) : (
                      <CSidebarNavItem
                        key={index}
                        name={item.name}
                        style={{ fontSize: "14px" }}
                        to={item.url}
                        fontIcon={`${item.icon} navbar-icon`}
                        id={
                          this.props.general.active_roles.group_name ===
                          "Alagoas"
                            ? "alagoas"
                            : ""
                        }
                      />
                    )
                  )}
                </React.Fragment>
              ) : (
                <CSidebarNavItem
                  key={index}
                  name={title.name}
                  to={title.url}
                  fontIcon={`${title.icon} navbar-icon`}
                  id={
                    this.props.general.active_roles.group_name === "Alagoas"
                      ? "alagoas"
                      : ""
                  }
                />
              )
            )}
          </CSidebarNav>
        </CSidebar>
      );
    }
  }
}

Sidebar.propTypes = propTypes;
Sidebar.defaultProps = defaultProps;

const mapStateToProps = state => ({
  general: state.general,
  user: state.user
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setMinimizeMenu, setMenu }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
